export default __webpack_public_path__ + "static/media/oxetrilhas_garota_recortado.cb77cd0b.png";